import { Card, CardContent, Typography } from "@mui/material";

import GrowthConversionAnalyticsPanel from "../../../components/GrowthConversionAnalyticsPanel";

const MonthlyGrowthPanel = ({
  growthAnalytics,
  analyticsLoading,
  periodDays,
  onPeriodChange,
}) => (
  <>
    <Typography fontWeight={700} fontSize={16} sx={{ mb: 1.5 }}>
      رشد ماهانه
    </Typography>
    <Card sx={{ borderRadius: "16px", boxShadow: "0 1px 3px rgba(0,0,0,0.08)", mb: 2 }}>
      <CardContent sx={{ py: 1.5, px: 2 }}>
        <GrowthConversionAnalyticsPanel
          analytics={growthAnalytics}
          loading={analyticsLoading}
          height={300}
          periodDays={periodDays}
          onPeriodChange={onPeriodChange}
          showFullAnalyticsLink
        />
      </CardContent>
    </Card>
  </>
);

export default MonthlyGrowthPanel;
